//埋点相关的接口
import api from "@/api";

 //登录发送的接口
export const loginifo=(type)=>{ return  api.axss("get", `/ocm-admin/theStatisticalTime/loginInform?type=10&loginType=${type}` )}


 //半小时不动页面或关闭浏览器或退出
 export const notmove=(type)=>{ return  api.axss("get", `/ocm-admin/theStatisticalTime/pageNotMove?type=10&LoginOutType=${type}` )}


 

 export const homecount=(data)=>{ return  api.axss("post", `/ocm-admin/home/count`,data )}

//台账相关
 export const accountstatus=()=>{ return  api.axss("get", `/ocm-oil-site/oil-account/statu` )}

 
 //搜索推荐
 export const getAssociate=(data)=>{ return  api.axss("post", `/ocm-search/search/getAssociate`,data )}

  //搜索推荐
  export const getSearchHistory=()=>{ return  api.axss("post", `/ocm-search/search/getSearchHistory`, )}

  //搜索推荐
  export const hisleClear=()=>{ return  api.axss("post", `/ocm-search/search/history-clear`, )}

    //搜索推荐
    export const sockedlist=()=>{ return  api.axss("get", `/ocm-admin/socked/all/socked/list`, )}

   //弹窗
   export const messageCenterList=(data)=>{ return  api.axss("post", `/ocm-admin/messageCenter/messageCenterList`,data )}

 
     //弹窗已读
     export const messageCentergetDetails=(id)=>{ return  api.axss("get", `/ocm-admin/messageCenter/getDetails/${id}`, )}

 